import useTranslation from "next-translate/useTranslation";
import { HomeMetricCardV2 as DashboardCard } from "components/ui/v2";

interface IKPIOrgAppreciationsProps {
  loading?: boolean;
  abandoned: [number, number];
  answered: [number, number];
  performance: number;
}

const KPIOrgAppreciations = (props: IKPIOrgAppreciationsProps) => {
  const { abandoned, answered, performance, loading } = props;
  const { t } = useTranslation("common");

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      <DashboardCard
        title={t("Appreciations abandonados")}
        value={abandoned[0] || 0}
        refValue={abandoned[1] || 0}
        loading={loading}
        popupInfo={t(
          "Se considera abandonado toda appreciation que ha sido comenzado y no es terminado en el tiempo establecido"
        )}
      />
      <DashboardCard
        title={t("Appreciations respondidas")}
        value={answered[0]}
        refValue={answered[1]}
        loading={loading}
        popupInfo={t(
          "Corresponde a las appreciation que han sido respondidos, a la fecha de la consulta"
        )}
      />
      <DashboardCard
        title={t("Rendimiento de appreciations")}
        value={performance}
        percent
        loading={loading}
        popupInfo={t(
          "Cantidad de appreciation que fueron abandonados por los usuarios de Groowcity"
        )}
      />
    </div>
  );
};

export default KPIOrgAppreciations;
